// The exercise library's body parts: each groups the catalog's muscle groups (muscleGroup), in the body's order (the
// list's groups follow it). Only "other" belongs to none, so it shows only when no part is picked
export const EXERCISE_REGIONS = [
  { key: 'chest', muscles: ['chest'] },
  { key: 'back', muscles: ['upper_back', 'lats', 'lower_back', 'traps'] },
  { key: 'shoulders', muscles: ['shoulders'] },
  { key: 'arms', muscles: ['biceps', 'triceps', 'forearms'] },
  { key: 'abs', muscles: ['abdominals'] },
  { key: 'legs', muscles: ['quadriceps', 'hamstrings', 'calves', 'adductors', 'abductors'] },
  { key: 'glutes', muscles: ['glutes'] },
  { key: 'fullBody', muscles: ['full_body'] },
  { key: 'cardio', muscles: ['cardio'] },
  { key: 'neck', muscles: ['neck'] },
];

// The parts the body map is made of. Their chips come first; full body, cardio and the neck (a small target on the
// map) follow on a line of their own
export const MAP_REGIONS = ['chest', 'back', 'shoulders', 'arms', 'abs', 'legs', 'glutes'];

export const regionOf = (muscle) => EXERCISE_REGIONS.find(({ muscles }) => muscles.includes(muscle))?.key ?? null;
